package com.essntl.core.utils.utils

fun <T> List<T>.update(
    predicate: (T) -> Boolean,
    update: (T) -> T,
): List<T> = map { element ->
    if (predicate(element)) update(element) else element
}

fun <T> List<T>.updateItemAtIndex(
    index: Int,
    updateItem: (T) -> T,
): List<T> = mapIndexed { i, element ->
    if (i == index) updateItem(element) else element
}

fun compareTables(
    table1: List<String>,
    table2: List<String>,
): Boolean {
    return table1.toSet().sorted() !=
        table2.toSet().sorted()
}
